import { render } from "./formula_areas.vue?vue&type=template&id=0853a04f"
import script from "./formula_areas.vue?vue&type=script&lang=js"
export * from "./formula_areas.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/formula_areas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0853a04f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0853a04f', __exports__)) {
    api.reload('0853a04f', __exports__)
  }
  
  module.hot.accept("./formula_areas.vue?vue&type=template&id=0853a04f", () => {
    api.rerender('0853a04f', render)
  })

}


export default __exports__